/**
 * W11.2 (MONITOR-DOMAIN-DESIGN-SEP10.md): the old /tenant/automations
 * loader's redirect target (App.tsx). Extracted into its own module (rather
 * than living inline in App.tsx, a component file) so it's importable by
 * its unit test without tripping react-refresh/only-export-components.
 *
 * `search` is the URL's full query string, leading `?` included or not
 * (both accepted, matching URLSearchParams's own tolerance). Drops
 * `?tab=run-plan` (Today is now the no-param default) and preserves every
 * other param verbatim — date, tab=activity/all/schedules/loops/calendars/
 * system, status, period, engine, etc.
 */
export function monitorAutomationsRedirectTarget(search: string): string {
  const params = new URLSearchParams(search)
  if (params.get('tab') === 'run-plan') params.delete('tab')
  const qs = params.toString()
  return `/tenant/monitor${qs ? `?${qs}` : ''}`
}
